module.exports = __webpack_public_path__ + "static/media/aaveg_logo.49e5c00d.jpeg";